import { ConsoleSink } from './ConsoleSink';
import { LogSink } from './Sink';

export class LoggingConfig {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static sink: LogSink | undefined = new ConsoleSink();
}
